import { render, staticRenderFns } from "./icma.vue?vue&type=template&id=0412c700"
import script from "./icma.vue?vue&type=script&lang=js"
export * from "./icma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports